import style from './thinking.module.scss'

export const Thinking = () => {
  return (
    <div className={style.thinking}>
      <div className={style.bouncingDot} />
      <div className={style.bouncingDot} />
      <div className={style.bouncingDot} />
    </div>
  )
}
